import { listObjectsWithNonEncodedKeys } from '../../s3';

export const BUCKET_OBJECTS_LIST_REQUEST = 'BUCKET_OBJECTS_LIST_REQUEST';
function actionListRequest() {
    return {
        type: BUCKET_OBJECTS_LIST_REQUEST,
    };
}

export const BUCKET_OBJECTS_LIST_SUCCESS = 'BUCKET_OBJECTS_LIST_SUCCESS';
function actionListReceive({
    NextContinuationToken,
    CommonPrefixes,
    Contents,
}) {
    return {
        type: BUCKET_OBJECTS_LIST_SUCCESS,
        data: { NextContinuationToken, CommonPrefixes, Contents },
    };
}

export const BUCKET_OBJECTS_LIST_FAILURE = 'BUCKET_OBJECTS_LIST_FAILURE';
function actionListFailure() {
    return {
        type: BUCKET_OBJECTS_LIST_FAILURE,
    };
}

export const BUCKET_OBJECTS_LIST_ADD = 'BUCKET_OBJECTS_LIST_ADD';
export function actionListAdd({ CommonPrefix, Content }) {
    return {
        type: BUCKET_OBJECTS_LIST_ADD,
        data: { CommonPrefix, Content },
    };
}

export function asyncActionList({
    Bucket,
    Prefix,
    MaxKeys,
    ContinuationToken,
}) {
    return async function(dispatch) {
        dispatch(actionListRequest());

        try {
            const params = {
                Bucket,
                Prefix,
                Delimiter: '/',
                MaxKeys,
            };

            if (ContinuationToken) {
                params.ContinuationToken = ContinuationToken;
            }

            const {
                data: { CommonPrefixes, Contents, NextContinuationToken },
            } = await listObjectsWithNonEncodedKeys(params);

            dispatch(
                actionListReceive({
                    NextContinuationToken,
                    CommonPrefixes,
                    Contents,
                }),
            );
        } catch (reason) {
            dispatch(actionListFailure());
        }
    };
}
